
import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ApparelOrder } from "@/types/models";
import { formatCurrency } from "@/lib/format";
import { getStatusColor } from '../utils/statusColors';

interface OrdersTableProps {
  orders: ApparelOrder[];
  onViewOrder: (order: ApparelOrder) => void;
}

const OrdersTable: React.FC<OrdersTableProps> = ({ orders, onViewOrder }) => {
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle>Orders</CardTitle>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Order ID</TableHead>
              <TableHead>Family</TableHead>
              <TableHead>Student</TableHead>
              <TableHead>Date</TableHead>
              <TableHead>Total</TableHead>
              <TableHead>Status</TableHead>
              <TableHead>Invoiced</TableHead>
              <TableHead></TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {orders.map((order) => (
              <TableRow key={order.id}>
                <TableCell className="font-medium">{order.id.substring(0, 8)}...</TableCell>
                <TableCell>{order.family?.name || "N/A"}</TableCell>
                <TableCell>
                  {order.student ? `${order.student.first_name} ${order.student.last_name}` : "Family Order"}
                </TableCell>
                <TableCell>{new Date(order.created_at).toLocaleDateString()}</TableCell>
                <TableCell>{formatCurrency(order.total_cents / 100)}</TableCell>
                <TableCell>
                  <Badge className={getStatusColor(order.status)}>
                    {order.status.charAt(0).toUpperCase() + order.status.slice(1)}
                  </Badge>
                </TableCell>
                <TableCell>
                  {order.added_to_invoice ? (
                    <Badge variant="outline" className="bg-green-50">
                      Yes
                    </Badge>
                  ) : (
                    <Badge variant="outline" className="bg-gray-50">
                      No
                    </Badge>
                  )}
                </TableCell>
                <TableCell>
                  <Button variant="ghost" onClick={() => onViewOrder(order)}>
                    View
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};

export default OrdersTable;
